import { useSelector } from 'react-redux';

function useGetSectionInfo(id) {
    return useSelector(state => {
        if (id === 'formButtons') {
            return {};
        }
        const section = state.sections.find(section => section.id === id);
        const fields = state.fields.filter(field => field.sectionId === id);
        const options = fields.reduce((arr, field) => {
            const option = state.options.filter(option => option.fieldId === field.id);
            if (option.length > 0) {
                arr.push(option);
            }
            return arr;
        }, []);

        const sectionSetting = state.settings.sections.find(item => item.id === section.id);
        const fieldSetting =
            fields.length > 0
                ? state.settings.fields.filter(item => fields.find(field => field.id === item.id))
                : undefined;

        const optionIDList = options.reduce((arr, option) => {
            option.forEach(value => {
                arr.push(value.id);
            });
            return arr;
        }, []);
        const optionSetting =
            optionIDList.length > 0
                ? state.settings.options.filter(item => optionIDList.includes(item.id))
                : undefined;
        const result = {
            section,
            fields,
            settings: { sections: sectionSetting }
        };

        if (fieldSetting && fieldSetting.length > 0) {
            result.settings.fields = fieldSetting;
        }

        if (options.length > 0) {
            result.options = options;
            if (optionSetting && optionSetting.length > 0) {
                result.settings.options = optionSetting;
            }
        }

        return result;
    });
}

export default useGetSectionInfo;
